import { render } from "./CardTwentySix.vue?vue&type=template&id=58ae3ff7"
import script from "./CardTwentySix.vue?vue&type=script&lang=js"
export * from "./CardTwentySix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__